import { render, staticRenderFns } from "./DailyReportViewer.vue?vue&type=template&id=04867d04&scoped=true"
import script from "./DailyReportViewer.vue?vue&type=script&lang=ts"
export * from "./DailyReportViewer.vue?vue&type=script&lang=ts"
import style0 from "./DailyReportViewer.vue?vue&type=style&index=0&id=04867d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04867d04",
  null
  
)

export default component.exports